import { formatTimezoneLabel } from './format-timezone-label';
import type { TimezoneOption } from './timezone-option.interface';

export function getTimezoneOptions(): TimezoneOption[] {
  const timeZones =
    typeof Intl.supportedValuesOf === 'function' ? Intl.supportedValuesOf('timeZone') : ['UTC'];

  return timeZones.map((value) => ({
    label: formatTimezoneLabel(value),
    value,
  }));
}
